module.exports = __webpack_public_path__ + "media/assets/icons/HFund company Grey-1ada29d4d4b98dc9a384a885421565e1.svg";